export const AUTH_PROMPTS = {
    auth_graphic_alt_text: "authentication graphic",
    logo_alt_text: "recruitment buddy logo",
    username: "Username",
    password: "Password",
    username_required: "Username is required",
    password_required: "Password is required",
    forgot_password: "Forgot Password?",
    login_btn: "Login",
    login_sso_btn: "Login using SSO"
}

export const NAVBAR_PROMPTS = {
    app_name: "Recruitment Buddy",
    logout: "Logout",
    dashboard: "Dashboard",
    candidate_list: "Candidate List",
    add_candidate: "Add Candidate",
    add_candidate_disabled: "Adding new candidates has been disabled.",
    candidate_pipeline: "Candidate Pipeline",
    search_candidate: "Search Candidate",
    logo_alt_text: AUTH_PROMPTS.logo_alt_text,
    new_version: "New Version",
    positions: "Positions",
    metrics: "Metrics"
}

export const DASHBOARD_PROMPTS = {
    candidates_overview: "Candidates Overview",
    total_candidates: "Total Candidates",
    cv: "CV",
    written: "Written",
    interview_1: "Interview 1",
    interview_2: "Interview 2",
    interview_m: "Interview M",
    offer: "Offer",
    joined: "Joined",
    panels_overview: "Panels Overview",
    panel_schedule_7_days: "Panel Schedule for Next 7 Days"
}

export const CANDIDATES_DOCUMENTS_PROMPTS = {
    document_heading: "Documents",
    add_document: "Add Document",
    no_documents_found: "No Documents Found",
    add_document_heading: "Add Document",
    upload_drag_drop: "Upload or drag and drop PDF files",
    unsupported_pdf: "Unsupported file type (Only PDFs are allowed)"
}

export const COMMENT_PROMPTS = {
    audit_comment_header_timestamp: "Timestamp",
    audit_comment_header_user: "User",
    audit_comment_header_event: "Event"
}

export const COMMENT_LIST_PROMPTS = {
    no_comments_added: "No Comments Added"
}

export const METRICS_PROMPTS = {
    page_heading: "Metrics",
    metric_type: "Metric type",
    pipeline_snapshot: "Pipeline snapshot",
    cv_added_monthly: "CV added monthly",
    success_ratio: "Success ratio",
    apply: "Apply",
    month: "Month",
    months: "Months",
    year: "Year",
    profile: "Profile",
    user: "User",
    breakdown_type: "Breakdown type",
    no_data: "No data available",
    loading: "Loading...",
    snapshot_time: "Snapshot time",
    date: "Date",
    total: "Total",
    by_profile: "By profile",
    added_count: "Added",
    success_count: "Success",
    ratio: "Ratio %",
    cv_added: "CV added",
    cv_rcvd: "CV received",
    cv_rw: "CV under review",
    cv_sel: "CV selected",
    int_1_schd: "Int 1 scheduled",
    int_1_done: "Int 1 done",
    int_2_done: "Int 2 done",
    int_m_done: "Int M done",
    interviews_done: "Interviews done",
    accepted: "Accepted",
    success_ratio_period: "View",
    success_ratio_monthly: "Monthly",
    success_ratio_yearly: "Yearly",
    success_ratio_by_user: "Success ratio by user",
    success_ratio_by_profile: "Success ratio by profile"
}